import React from 'react'
import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'
import { Box, HR } from 'ui/acro'

const ListContainer = styled(Box)(() =>
  css({
    flexDirection: 'row',
    width: '100%',
    '.support-link': {
      fontFamily: 'proxima-nova',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 400,
      letterSpacing: '-0.01em',
      textAlign: 'left',
      color: '#000',
      '@media only screen and (max-width: 767px)': {
        span: {
          textDecoration: 'underline'
        }
      }
    },
    '.support-link:hover': {
      '@media only screen and (min-width: 768px)': {
        borderLeft: '3px solid black',
        backgroundColor: '#F2F2F2',
        marginLeft: '-3px'
      }
    },
    '.active': {
      fontWeight: '700',
      '@media only screen and (max-width: 767px)': {
        backgroundColor: '#F2F2F2',
        fontWeight: 'inherit'
      }
    }
  })
)

const ArticleList = ({ articleList, category, hideLine = false }) => {
  return (
    <ListContainer>
      {articleList &&
        articleList.map(({ fields }) => (
          <Box
            key={fields.title}
            as={Link}
            display='block'
            to={`/support/${category}/${fields.slug}`}
            className={
              window.location.pathname.includes(fields.slug)
                ? 'support-link unstyled active'
                : 'support-link unstyled'
            }
            maxWidth='919px'
          >
            <Box
              className='support-link-inner'
              padding={
                !hideLine ? ['15px 0', '15px 0', '15px'] : '5px 5px 5px 8px;'
              }
              my={!hideLine ? 'auto' : '20px'}
              lineHeight={['20px', '20px', '20px', '24.96px']}
            >
              <span>{fields.title}</span>
            </Box>
            {!hideLine && (
              <HR
                maxWidth='100%'
                ml={'15px'}
                mr={'15px'}
                display={['none', 'block', 'block']}
              />
            )}
          </Box>
        ))}
    </ListContainer>
  )
}

export default ArticleList
